import {
  Button,
  Dropdown,
  generateLinkWithParams,
  getApiPath,
  Link,
  linkPlaceholders,
  openNewTab,
  OverflowContainer,
  routing,
  RowFlex,
  sortAndFormatOptions,
  Spinner,
  useAxios,
  useVendors,
} from "common";
import { orderBy } from "lodash";
import { uniq } from "ramda";
import { useMemo, useState } from "react";
import {
  BrandName,
  BrandRow,
  CategoryColumn,
  CategoryColumnHeader,
  Columns,
  Container,
} from "./styles";

const VendorBrandListTable = () => {
  const [brandList, setBrandList] = useState([]);

  const { loading, callAxios: getBrands } = useAxios();
  const [vendorId, setVendorId] = useState("");

  const vendors = useVendors();

  const onExport = () => {
    openNewTab(getApiPath(`/vendors/${vendorId}/brands/export?statuses=Open`));
  };

  const categories = useMemo(
    () =>
      orderBy(
        uniq(
          brandList.map((br) => br.brandRequest?.category ?? "").filter(Boolean)
        ),
        ["sortOrder", (c) => c.name.trim().toLowerCase()],
        "asc"
      ),
    [brandList]
  );

  return (
    <Container>
      <RowFlex extend responsive>
        <RowFlex>
          <h3>Brand List</h3>
          <Dropdown
            value={vendorId}
            options={sortAndFormatOptions({
              list: vendors,
              valueKey: "id",
              labelKey: "name",
            })}
            label="Select Vendor"
            onChange={(v) => {
              setVendorId(v);
              setBrandList([]);

              if (!v) return;

              getBrands({
                url: `/vendors/${v}`,
                method: "GET",
                params: {
                  populate: {
                    path: "vendorRequests",
                    populate: { path: "brandRequest", populate: "category" },
                  },
                },
              }).then((v) => {
                const list = v.data.vendorRequests.filter(
                  (vr) => vr.status === "Open"
                );
                setBrandList(list);
              });
            }}
          />
          {loading && <Spinner inline />}
        </RowFlex>
        {brandList.length > 0 && (
          <Button secondary fit onClick={() => onExport()}>
            Export
          </Button>
        )}
      </RowFlex>

      <OverflowContainer>
        <Columns responsive>
          {categories.map((category) => {
            const requests = brandList.filter(
              (b) => b.brandRequest?.category?.name === category.name
            );
            return (
              <CategoryColumn key={category.id}>
                <CategoryColumnHeader>{category.name}</CategoryColumnHeader>
                <OverflowContainer>
                  {requests.map((r) => {
                    return (
                      <BrandRow key={r.id}>
                        <Link
                          target="_blank"
                          to={generateLinkWithParams(
                            routing.brandRequests.view,
                            {
                              [linkPlaceholders.brandRequestId]:
                                r.brandRequest?.id,
                            }
                          )}
                        >
                          <BrandName>{r.brandRequest?.brandName}</BrandName>
                        </Link>
                      </BrandRow>
                    );
                  })}
                </OverflowContainer>
              </CategoryColumn>
            );
          })}
        </Columns>
      </OverflowContainer>
    </Container>
  );
};

export default VendorBrandListTable;
